import {atomButtonColors, atomButtonDesigns} from '@s-ui/react-atom-button'

const DEALER_TRACKS = {
  PHONE_VIEW: {
    event: 'Professional Stock Phone Showed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Professional Stock Phone Called'
    }
  }
}

const DEALER_INFO_TRACKS = {
  PHONE_VIEW: {
    event: 'Professional Stock Phone Showed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Dealer Information Phone Called'
    }
  }
}

const DEALER_HEADER_TRACKS = {
  PHONE_VIEW: {
    event: 'Professional Stock Phone Showed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Stock Dealer Header Phone Called'
    }
  }
}

const DEALER_CONFIGURATOR_SUCCESS_TRACKS = {
  PHONE_VIEW: {
    event: 'Professional Stock Phone Showed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Car Configurator Phone Called',
      hit_origin: 'car configurator final page'
    }
  }
}

const DEALER_CONFIGURATOR_POPUP_TRACKS = {
  PHONE_VIEW: {
    event: 'Professional Stock Phone Showed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Car Configurator Phone Called',
      hit_origin: 'pop up ask phone'
    }
  }
}

const DEALER_SEARCH_TRACKS = {
  PHONE_VIEW: {
    event: 'Professional Stock Phone Showed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Dealer Search Phone Called'
    }
  }
}

const DEALER_PROVINCE_SEARCH_TRACKS = {
  PHONE_VIEW: {
    event: 'Professional Stock Phone Showed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Dealer Province Search Phone Called'
    }
  }
}

const VEHICLE_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Detail Phone Called'
    }
  }
}

const NET_AD_DETAIL_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed',
    data: {
      list_type: 'ad card respuesta net'
    }
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Net Phone Called',
      page_name_origin: 'assistant',
      page_type: 'form'
    }
  }
}

const SELLER_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Detail Dealer Phone Called'
    }
  }
}

const RELATED_VEHICLE_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Recommended Phone Called'
    }
  }
}

const FAVORITE_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Favorite Phone Called'
    }
  }
}

const FAVORITE_DEALER_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Favorite Dealer Phone Called'
    }
  }
}

const ADS_LIST_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Ads List Phone Called'
    }
  }
}

const FAVORITE_RECOMMENDED_ADS_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Favorite Recommended Phone Called'
    }
  }
}

const FINANCING_DEALER = {
  PHONE_VIEW: {
    event: 'Financed Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Financed Purchase Phone Called'
    }
  }
}

const IMAGE_GALLERY_TRACKS = {
  PHONE_VIEW: {
    event: 'Image Gallery Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Image Gallery Phone Called',
      hit_origin: 'gallery'
    }
  }
}

const AD_DETAIL_IMAGE_GALLERY_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed',
    data: {
      hit_origin: 'gallery_detail_page'
    }
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Image Gallery Phone Called',
      hit_origin: 'gallery'
    }
  }
}

const RESERVATION_PAYMENT_CONFIRMED_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed'
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      lead_type: 'Reservation Payment Confirmed Phone Called'
    }
  }
}

const USER_ALERTS_MISSED_MATCHES_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed',
    data: {
      list_type: 'listado de alertas anteriores'
    }
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      list_type: 'listado de alertas anteriores',
      lead_type: 'Alert Match Phone Viewed'
    }
  }
}

const USER_ALERTS_RECENT_MATCHES_TRACKS = {
  PHONE_VIEW: {
    event: 'Phone Viewed',
    data: {
      list_type: 'listado de novedades de una alerta'
    }
  },
  PHONE_CALLED: {
    event: 'Lead Triggered',
    data: {
      list_type: 'listado de novedades de una alerta',
      lead_type: 'Alert Match Phone Called'
    }
  }
}

const SIZES = {small: 'small', medium: 'medium', large: 'large'}

const TYPES = {
  button: 'button',
  link: 'link'
}

const COLORS = atomButtonColors

const DESIGNS = {
  FLAT: atomButtonDesigns.FLAT,
  OUTLINE: atomButtonDesigns.OUTLINE,
  SOLID: atomButtonDesigns.SOLID
}

const DESINGS_ICON = {
  SOLID: 'solid',
  OUTLINE: 'outline'
}

/**
 * dealer - dealer page
 * dealerHeader - header from dealer page
 * dealerInformation - dealer info from dealer page
 * relatedVehicle - vehicle related to other one
 * seller - dealer in a vehicle detail page
 * vehicle - vehicle detail page
 */
const TARGETS = {
  adsList: 'adsList',
  dealer: 'dealer',
  dealerConfiguratorSuccess: 'dealerConfiguratorSuccess',
  dealerConfiguratorPopup: 'dealerConfiguratorPopup',
  dealerHeader: 'dealerHeader',
  dealerInformation: 'dealerInformation',
  dealerProvinceSearch: 'dealerProvinceSearch',
  dealerSearch: 'dealerSearch',
  favorite: 'favorite',
  favoriteDealer: 'favoriteDealer',
  favoriteRecommendedAds: 'favoriteRecommendedAds',
  financingDealer: 'financingDealer',
  imageGallery: 'imageGallery',
  adDetailImageGallery: 'adDetailImageGallery',
  relatedVehicle: 'relatedVehicle',
  reservationPaymentConfirmed: 'reservationPaymentConfirmed',
  seller: 'seller',
  userAlertsMissedMatches: 'userAlertsMissedMatches',
  userAlertsRecentMatches: 'userAlertsRecentMatches',
  vehicle: 'vehicle',
  netAdDetail: 'netAdDetail'
}

const TRACKS = {
  [TARGETS.adsList]: ADS_LIST_TRACKS,
  [TARGETS.dealer]: DEALER_TRACKS,
  [TARGETS.dealerHeader]: DEALER_HEADER_TRACKS,
  [TARGETS.dealerInformation]: DEALER_INFO_TRACKS,
  [TARGETS.dealerProvinceSearch]: DEALER_PROVINCE_SEARCH_TRACKS,
  [TARGETS.dealerSearch]: DEALER_SEARCH_TRACKS,
  [TARGETS.favorite]: FAVORITE_TRACKS,
  [TARGETS.favoriteDealer]: FAVORITE_DEALER_TRACKS,
  [TARGETS.favoriteRecommendedAds]: FAVORITE_RECOMMENDED_ADS_TRACKS,
  [TARGETS.financingDealer]: FINANCING_DEALER,
  [TARGETS.imageGallery]: IMAGE_GALLERY_TRACKS,
  [TARGETS.adDetailImageGallery]: AD_DETAIL_IMAGE_GALLERY_TRACKS,
  [TARGETS.relatedVehicle]: RELATED_VEHICLE_TRACKS,
  [TARGETS.reservationPaymentConfirmed]: RESERVATION_PAYMENT_CONFIRMED_TRACKS,
  [TARGETS.seller]: SELLER_TRACKS,
  [TARGETS.userAlertsMissedMatches]: USER_ALERTS_MISSED_MATCHES_TRACKS,
  [TARGETS.userAlertsRecentMatches]: USER_ALERTS_RECENT_MATCHES_TRACKS,
  [TARGETS.vehicle]: VEHICLE_TRACKS,
  [TARGETS.netAdDetail]: NET_AD_DETAIL_TRACKS,
  [TARGETS.dealerConfiguratorSuccess]: DEALER_CONFIGURATOR_SUCCESS_TRACKS,
  [TARGETS.dealerConfiguratorPopup]: DEALER_CONFIGURATOR_POPUP_TRACKS
}

export {COLORS, DESIGNS, DESINGS_ICON, SIZES, TARGETS, TYPES, TRACKS}
